import { useContext, useEffect, useRef } from "react";
import { AmplitudeContext } from "./AmplitudeProvider";
import { getEnabledFlagKeys, setFeatureFlagIdentifyProperty } from "./featureFlagIdentify";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags/useFlags";
import { useAssumeUser } from "@/providers/AssumeUserProvider";

const AmplitudeFeatureFlagIdentify = () => {
  const amplitude = useContext(AmplitudeContext);
  const { assumedUser } = useAssumeUser();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const lastSentFlagKeys = useRef<string | null>(null);

  const skipBecauseImpersonating = Boolean(assumedUser);

  useEffect(() => {
    if (!flagsLoaded || skipBecauseImpersonating) {
      return;
    }

    const enabledFlagKeys = getEnabledFlagKeys(flags);
    if (!enabledFlagKeys) {
      return;
    }

    const serializedFlagKeys = JSON.stringify(enabledFlagKeys);
    if (lastSentFlagKeys.current === serializedFlagKeys) {
      return;
    }

    const identify = new amplitude.Identify();
    setFeatureFlagIdentifyProperty(identify, enabledFlagKeys);
    amplitude.identify(identify);
    lastSentFlagKeys.current = serializedFlagKeys;
  }, [amplitude, flags, flagsLoaded, skipBecauseImpersonating]);

  return null;
};

export default AmplitudeFeatureFlagIdentify;
